import React from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@linaria/core'
import { i18n } from '@fs/zion-locale'
import { Link } from '@fs/zion-router'
import { baseUrl } from '@fs/zion-config'
import logo from '../images/FSLogoBlack.svg'

const logoCss = css`
  display: block;
  margin: 0 -8px 2px;
`

export default function FSLogo() {
  const { t } = useTranslation()
  const alt = t('footer.familysearch', 'FamilySearch')

  return (
    <Link to={`${baseUrl}/${i18n.language}`} noLinkStyles className={logoCss} linkName="ff_fslogo" external>
      <img src={logo} height="42.05" alt={alt} aria-label={alt} />
    </Link>
  )
}
